import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CarsWidgetFormType } from '../models/cars-widget-form.interfaces';
import { CarsWidget } from '../models/cars-widget.interface';
import { CarsFormValidationService } from './cars-form-validation.service';

@Injectable({
  providedIn: 'root'
})
export class CarsFormSubmissionService {
  constructor(private validationService: CarsFormValidationService) {}

  hasValidationErrors(
    errors: {
      locationError: string;
      pickupDateError: string;
      pickupTimeError: string;
      dropoffDateError: string;
      dropoffTimeError: string;
    },
    form: FormGroup<CarsWidgetFormType>
  ): boolean {
    return form.invalid || this.hasErrorMessages(errors);
  }

  private hasErrorMessages(errors: Record<string, string>): boolean {
    return Object.values(errors).some((error) => !!error);
  }

  validateAndGetErrors(
    form: FormGroup<CarsWidgetFormType>,
    content: CarsWidget
  ): ReturnType<typeof this.validationService.validateForm> {
    return this.validationService.validateForm(form, content);
  }
}
